import CookieConsentApi from "../../cookie-consent/cookie-consent-api";
import { setHeaderCssTop } from "../../../molecules/notification-bar/notification-bar";

const initMarketSelector = () => {
    const marketBar = document.querySelector('.new-market-seletor');

    if (marketBar !== null && !marketBar.classList.contains('new-market-seletor--hide')) {
        document.querySelector('html').classList.add('market-bar--visible')
    } else {
        document.querySelector('html').classList.add('market-bar--no-market-bar')
    }

    if (marketBar === null) {
        return;
    }

    document.addEventListener('main-menu-open', () => {
        marketBar.style.zIndex = "10";
        marketBar.classList.add('js-z-index-change');
    });
    document.addEventListener('main-menu-close', () => {
        marketBar.style.zIndex = "";
        marketBar.classList.remove('js-z-index-change');
    });

    const closeMarketBar = () => {
        const marketSelectBar = document.querySelector('.new-market-seletor');
        marketSelectBar.classList.add('new-market-seletor--hide');

        document.querySelector('html').classList.remove('market-bar--visible');
        document.querySelector('.header')?.classList.remove('header--market-bar-active');

        setTimeout(() => {
            marketSelectBar.style.position = 'fixed';
        }, 200);
    }

    const onContinueClick = () => {
        closeMarketBar();

        const currMarketCode = document.querySelector('.new-dropdown__list-item--current').dataset['code']

        const cookieConsentData = CookieConsentApi.get();
        const hasfunctionalCookieConsent = cookieConsentData['cookies-groups']
            .filter((group) => group.name === 'functionalcookies')[0].approved;
        if (hasfunctionalCookieConsent) {
            const cookieName = 'marketSelect';
            const cookieValue = encodeURIComponent(JSON.stringify({
                code: currMarketCode,
            }));
            const exdays = 365;

            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toGMTString();
            document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";

            document.dispatchEvent(new CustomEvent('marketPicked', {}));
        } else {
            console.warn('You need to accept Functional Cookies in order for settings to be remembered + marketSelect needs to be stored as a Functional Cookie');
        }
    };

    // backup since BE seems to lag 1 request before it realises
    const hasChoosenMarket = document.cookie.split('marketSelect').length > 1;
    const isScriptPage = document.querySelector('.script-page') !== null;

    if (hasChoosenMarket || isScriptPage) {
        const marketSelectBar = document.querySelector('.new-market-seletor');
        document.querySelector('.header')?.classList.remove('header--market-bar-active');
        if (marketSelectBar) {
            marketSelectBar.classList.add('new-market-seletor--hide');
            $('html').removeClass('market-bar--visible');
            $('html').addClass('market-bar--no-market-bar');
            marketSelectBar.style.position = 'fixed';
            setHeaderCssTop();
        }

        return; // <===== NB we bail out here
    } else {
        document.querySelector('.header')?.classList.add('header--market-bar-active');
    }

    const continueBtn = document.querySelector('.new-market-seletor__btn');
    const closeButtons = document.querySelectorAll('.new-market-seletor__close-btn');
    if (continueBtn) {
        continueBtn.removeEventListener('click', onContinueClick);
        continueBtn.addEventListener('click', onContinueClick);
    }
    if (closeButtons.length) {
        closeButtons.forEach((btn) => {
            btn.removeEventListener('click', closeMarketBar)
            btn.addEventListener('click', closeMarketBar)
        });
    }
}

const initHeader = () => {
    const header = document.querySelector('.header');
    if (header !== null) {
        setTimeout(() => {
            document.querySelector('html').classList.remove('header-run-animation');
            document.querySelector('html').classList.add('header-animation-done');
        }, 1000); // 0.2s delayed start + 0.8s animation

        const fixLangSwitcherZIndexOnOpen = () => {
            const langSwitcher = document.querySelector('.language-switcher__button');
            const header = document.querySelector('.header');
            let isLangSwitcherOpen = false;
            if (langSwitcher && header) {
                const onClose = () => {
                    header.style.zIndex = '';
                    isLangSwitcherOpen = !isLangSwitcherOpen;
                }
                const onOpen = () => {
                    header.style.zIndex = 999999999;
                    isLangSwitcherOpen = !isLangSwitcherOpen;
                }
                langSwitcher.addEventListener('click', () => {
                    if (isLangSwitcherOpen) {
                        onClose();
                    } else {
                        onOpen();
                    }
                })
                const onClickOutside = () => {
                    document.addEventListener('click', (e) => {
                        const node = e.target;
                        if (node.closest('.language-switcher') === null) {
                            onClose();
                        }
                    });
                }
                onClickOutside();
            }
        }
        fixLangSwitcherZIndexOnOpen();
    }

    // Desktop menu dropdown
    document.querySelectorAll('[data-handle-desktop-dropdown]').forEach(function (button) {
        button.addEventListener('click', function () {
            if (button.getAttribute('aria-expanded') === 'true') {
                closeAllDesktopDropdowns();
            } else {
                openDesktopDropdown(button);
            }
        });
    });

    document.querySelectorAll('[data-close-all-desktop-dropdowns]').forEach(function (button) {
        button.addEventListener('click', function () {
            closeAllDesktopDropdowns();
        });
    });

    const openDesktopDropdown = (button) => {
        closeAllDesktopDropdowns();
        document.querySelector('.header__desktop-menu-overlay').style.display = 'block';
        button.setAttribute('aria-expanded', 'true');
        document.getElementById(button.getAttribute('aria-controls')).inert = false;
        button.focus();
        setDesktopDropdownInertElements(true);
    }

    const closeAllDesktopDropdowns = () => {
        document.querySelector('.header__desktop-menu-overlay').style.display = 'none';
        document.querySelectorAll('.header__desktop-links button[aria-expanded="true"]').forEach(function (button) {
            button.setAttribute('aria-expanded', 'false');
            document.getElementById(button.getAttribute('aria-controls')).inert = true;
            button.focus();
            setDesktopDropdownInertElements(false);
        });
    }

    const setDesktopDropdownInertElements = (inertVal) => {
        document.querySelectorAll('#js-skip-link, .alertbar, .hero, main, footer').forEach(function (el) {
            el.inert = inertVal;
        });
    }

    // Escape keyup
    document.addEventListener('keyup', function (e) {
        if (e.code === 'Escape') {
            closeAllDesktopDropdowns();
        }
    });
}

const init = () => {
    initMarketSelector();
    initHeader();
}

export default init;
